
import {defineComponent} from "vue";
import CatalogBuildStatus from "@/components/layouts/catalog/CatalogBuildStatus.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import BaseCardBody from "@/components/UI/Bootstrap/Card/BaseCardBody.vue";
import BaseCard from "@/components/UI/Bootstrap/Card/BaseCard.vue";
import BaseCardHeader from "@/components/UI/Bootstrap/Card/BaseCardHeader.vue";
import {AbilityContext} from "@/context/AbilityContext";
import ProductSelectionBaseSyncHistoryContent
  from "@/components/layouts/catalog/product-selection/ProductSelectionBaseSyncHistoryContent.vue";

export default defineComponent({
  name: "PharmacySoftware",
  components: {
    ProductSelectionBaseSyncHistoryContent,
    BaseCardHeader,
    BaseCard,
    BaseCardBody,
    BaseTitle, CatalogBuildStatus
  },
  data: () => ({
    contentKey: 0,
  }),
  computed: {
    AbilityContext() {
      return AbilityContext
    }
  },
  methods: {
    reloadContent(): void {
      this.contentKey++;
    }
  },
});
